import React from 'react';
import cn from 'classnames';
import { NavLink } from 'react-router-dom';

import LogoIconBase from 'assets/img/logo-icon.svg';
import LogoFullBase from 'assets/img/logo.svg';

import { Icon } from 'components/shared/Icon';

import { UserMenu } from './components/UserMenu';
import { Menu } from './components/Menu';

import styles from './Sidebar.module.scss';

const LogoIcon = LogoIconBase as unknown as React.ComponentType<{
  className?: string;
}>;
const Logo = LogoFullBase as unknown as React.ComponentType<{
  className?: string;
}>;

const Sidebar = ({
  className,
  collapsed,
  isAuthenticated,
  onCollapseClick,
}: {
  className: any;
  collapsed: any;
  isAuthenticated: any;
  onCollapseClick: any;
}) => (
  <div
    className={cn(
      styles.sidebar,
      { [styles.sidebarCollapsed]: collapsed },
      className,
    )}
  >
    <div className={styles.collapse} onClick={onCollapseClick}>
      <Icon
        className={styles.collapseIcon}
        name={collapsed ? 'chevronRight' : 'chevronLeft'}
      />
    </div>
    <div className={styles.inner}>
      <NavLink
        className={cn(styles.logo, { [styles.logoCollapsed]: collapsed })}
        to={isAuthenticated ? '/dashboard' : '/'}
      >
        {collapsed ? (
          <LogoIcon className={styles.logoImg} />
        ) : (
          <Logo className={styles.logoImg} />
        )}
      </NavLink>
      <Menu collapsed={collapsed} />
    </div>

    <UserMenu collapsed={collapsed} />
  </div>
);

export default React.memo(Sidebar) as any;
